import { myApi } from '../../config/axiosConfig';

// =========================================
// FUNCION PARA OBTENER UNIDADES DETENIDAS ACTIVAS
// =========================================

export const getUnidadesDetenidasActivas = async () => {

    const response = await myApi.get('/events/active');

    return response.data;

}

// =========================================
// FUNCION PARA OBTENER HISTORIAL UNIDADES DETENIDAS
// =========================================

export const getUnidadesDetenidasHistorial = async () => {

    const response = await myApi.get('/events/closed');

    return response.data;

}